import { Component } from "react";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { countryActionId, toastError, toastSuccess, visaIdTypeActionId, BASE_URL } from "../../../utils/constants";
import { emailValidator, mobileNoValidator } from "../../../utils/Validator";
import Resizer from "react-image-file-resizer";
import Modal from "react-modal";
import DatePicker from "react-datepicker";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import Loader from "../../../utils/Loader";
import { fill_action } from "../../../actions/fillCombo_action";
import Passport_Front_1008_VIS_903747 from "../../../files/Passport_Front_1008_VIS_903747.jpeg"
import {
    getDelegateVisaInvitation_action,
    getDelegateVisaApplication_action,
    getDetailsVisaApplicationDelegate_action,
    updateDelegateVisaApproval_action,
    getDelegateVisaApplicationExportData_action
} from "../../../actions/admin_module_action/delegate_visa_approval_action/delegate_visa_approval_action";
class DelegateVisaForm extends Component {

    // initialize constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            is_add: false,
            is_update: false,
            isView: false,
            isDelOpen: false,
            passportFilePath: "",

            // fields
            firstName: '',
            lastName: '',
            middleName: '',
            email: '',
            countryId: '',
            countryName: "",
            mobile: '',
            idTypeId: '',
            passportNo: '',
            passportIssueDate: "",
            passportExpiryDate: "",
            passportFrontImage: '',
            passportImage: '',
            passportFrontImageType: '',
            VisaApplicationFormID: '',
            // List
            visaApplicationList: [],
            countryList: [],
            idTypeList: [],
            passportFrontImageList: [],
            passportFrontImageTypeList: [],

            // err messages
            firstNameErr: '',
            lastNameErr: '',
            emailErr: '',
            countryIdErr: '',
            mobileErr: '',
            idTypeIdErr: '',
            passportNoErr: '',
            passportIssueDateErr: "",
            passportExpiryDateErr: "",
            passportFrontImageErr: '',
            url: '',
        }
        this.OnCancel = this.OnCancel.bind(this)
        this.inputValidate = this.inputValidate.bind(this)
        this.getFillList = this.getFillList.bind(this)
        this.renderVisaApplicationList = this.renderVisaApplicationList.bind(this)
        this.onFilePick = this.onFilePick.bind(this)
        this.onPdfSelect = this.onPdfSelect.bind(this)
        this.resizeFile = this.resizeFile.bind(this)
        this.handleAddMore = this.handleAddMore.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.ClearValue = this.ClearValue.bind(this)
        this.handleUpdate = this.handleUpdate.bind(this)
        this.getDetails = this.getDetails.bind(this)
        this.emailValidation = this.emailValidation.bind(this)
        this.onCrossClick = this.onCrossClick.bind(this)
        this.mobileValidation = this.mobileValidation.bind(this)
        this.onDocDelete = this.onDocDelete.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
    }

    componentDidMount() {
        this.getFillList(countryActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "")
        // this.getFillList(visaIdTypeActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "")
        this.setState({
            delegateId: this.props.location.state != "" && this.props.location.state.DelegateRegistrationID != null && this.props.location.state.DelegateRegistrationID != '' ? this.props.location.state.DelegateRegistrationID : '',
        })
        this.getDetails(this.props.location.state != "" && this.props.location.state.DelegateRegistrationID != null &&
            this.props.location.state.DelegateRegistrationID != '' ? this.props.location.state.DelegateRegistrationID : '')

        const url = BASE_URL.split('/api')
        this.setState({ url: url[0] })
    }

    // get Fill List
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props.fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    // Country List
                    if (actionID === countryActionId) {
                        console.log("country data", data.data)
                        this.setState({
                            countryList: data.data,
                            isLoading: false
                        })
                    }
                    // visa  id type
                    if (actionID === visaIdTypeActionId) {
                        console.log("visaIdTypeActionId data", data.data)
                        this.setState({
                            idTypeList: data.data,
                            isLoading: false
                        })
                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // On cancel Click
    OnCancel() {
        // this.props.navigate('/visaApplication')
        this.props.navigate(-1)
    }

    // Input Fields Validation
    inputValidate() {
        const { firstName, lastName, email, countryId, mobile, idTypeId, passportNo, passportFrontImage, passportExpiryDate, passportIssueDate } = this.state
        if (firstName.trim() == "") {
            this.setState({ firstNameErr: "Please Enter first Name" })
        }
        if (lastName.trim() == "") {
            this.setState({ lastNameErr: "Please Enter last Name" })
        }
        if (email.trim() == "") {
            this.setState({ emailErr: "Please Enter email" })
        }
        // if (email != "") {
        //     var emailError = emailValidator(email)
        //     if (emailError != '') {
        //         this.setState({ emailErr: emailError })
        //     }
        // }
        if (countryId == "") {
            this.setState({ countryIdErr: "Please select country" })
        }
        if (mobile.trim() == "") {
            this.setState({ mobileErr: "Please Enter mobile" })
        }
        // if (mobile != "") {
        //     var mobileError = mobileNoValidator(mobile)
        //     if (mobileError != '') {
        //         this.setState({ mobileErr: mobileError })
        //     }
        // }
        if (idTypeId == "") {
            this.setState({ idTypeIdErr: "Please select id type" })
        }
        if (passportNo.trim() == "") {
            this.setState({ passportNoErr: "Please Enter passport No" })
        }
        if (passportFrontImage == "") {
            this.setState({ passportFrontImageErr: "Please upload passport Front Image" })
        }
        if (passportIssueDate == "") {
            this.setState({ passportIssueDateErr: "Please Select Passport Issue Date" })
        }
        if (passportExpiryDate == "") {
            this.setState({ passportExpiryDateErr: "Please Select Passport Expiry Date" })
        }
    }

    // render Visa Application
    renderVisaApplicationList() {
        const { visaApplicationList } = this.state
        return (
            <ul class="list-group " style={{ position: 'relative', zIndex: 1 }}>
                {
                    visaApplicationList.length > 0 && visaApplicationList.map((data, index) => (
                        <li class="list-group-item" key={Math.random()}>
                            <div className="added-more p-3 rounded-2">
                                <h5 style={{ color: "#0056ff" }}>Added Visa Application {++index}</h5>
                                <div className="row mt-4">
                                    <div className="col-md-4">
                                        <h6>First Name: {data.firstName}</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>Middel Name: {data.middleName}</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>Last Name: {data.lastName}</h6>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-4">
                                        <h6>Email: {data.email}</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>Country: {data.countryName}</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>Mobile: {data.mobile}</h6>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-4">
                                        <h6>ID Type:  {data.idTypeName}</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>Passport No: {data.passportNo}</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>Passport Issue Date: {(data.passportIssueDate).toDateString()}</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <h6>Passport Expiry Date: {(data.passportExpiryDate).toDateString()}</h6>
                                    </div>
                                    <div className="col-md-4">
                                        {/* <h6>Passport Front Page</h6> */}
                                        <img
                                            src={data.passportFrontImage}
                                            style={{ width: '200px', height: '80px', display: 'block' }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <hr className="m-1" />

                        </li>
                    ))
                }
            </ul>
        )
    }

    emailValidation(e) {
        var emailError = emailValidator(e.target.value)
        this.setState({ email: e.target.value })
        if (emailError != '') {
            this.setState({ emailErr: emailError })
        }
        else {
            this.setState({ emailErr: '' })
        }
    }

    mobileValidation(e) {
        var mobileError = mobileNoValidator(e.target.value)
        this.setState({ mobile: e.target.value })
        if (mobileError != '') {
            this.setState({ mobileErr: mobileError })
        }
        else {
            this.setState({ mobileErr: '' })
        }
    }

    onFilePick = async (e, file) => {
        e.preventDefault()
        const { } = this.state
        console.log('file', file)
        if (file.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
                    file[0]['name'].toString().toLowerCase().includes('.png') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpg')
                ) {
                    if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
                    ) {
                        image = await this.resizeFile(file[0]);
                        this.setState({ passportFrontImage: image, passportFrontImageErr: '' })
                    }
                    else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
                        image = await this.onPdfSelect(file[0]);
                        this.setState({ passportFrontImage: image, passportFrontImageErr: '' })
                    }
                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")

                    }
                    this.setState({ passportFrontImageType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
                } else {
                    toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')
                }
            }
        }
    }

    onPdfSelect = (file) =>
        new Promise((resolve) => {
            let base64;
            // FileReader function for read the file.
            let fileReader = new FileReader();
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                // Print data in console
                resolve(base64);
            };
            // Convert data to base64
            fileReader.readAsDataURL(file);
        });

    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });

    handleAddMore() {
        const { visaApplicationList, passportFrontImageList, passportFrontImageTypeList, firstName, lastName, middleName, email, countryId,
            mobile, idTypeId, passportNo, passportFrontImage, passportFrontImageType, countryList, idTypeList,
            firstNameErr, lastNameErr, emailErr, countryIdErr, mobileErr, idTypeIdErr, passportNoErr, passportFrontImageErr, passportExpiryDate,
            passportExpiryDateErr, passportIssueDate, passportIssueDateErr
        } = this.state
        this.inputValidate()
        if (firstName != '' && countryId != '' &&
            lastName != '' && mobile != '' &&
            email != '' && idTypeId != '' &&
            passportNo != '' && passportFrontImage != '' && passportFrontImageType != '' && passportIssueDate != "" && passportExpiryDate != "") {
            if (firstNameErr == '' && lastNameErr == '' && emailErr == '' && countryIdErr == '' && mobileErr == '' && idTypeIdErr == '' &&
                passportNoErr == '' && passportFrontImageErr == '' && passportExpiryDateErr == '' && passportIssueDateErr == '') {
                console.log('fields', idTypeId)
                var countryName = ''
                var idTypeName = ''

                countryList.length > 0 && countryList.map(data => {
                    if (data.Code == countryId) {
                        countryName = data.Description
                    }
                })
                idTypeList.length > 0 && idTypeList.map(data => {
                    if (data.FormDocumentTypeID == idTypeId) {
                        idTypeName = data.Name
                    }
                })
                visaApplicationList.push({
                    'SeqNo': visaApplicationList.length + 1,
                    'firstName': firstName,
                    'middleName': middleName,
                    'lastName': lastName,
                    'email': email,
                    'countryId': countryId,
                    'countryName': countryName,
                    'mobile': mobile,
                    'idTypeId': idTypeId,
                    'idTypeName': idTypeName,
                    'passportNo': passportNo,
                    'passportFrontImage': passportFrontImage,
                    'passportIssueDate': passportIssueDate,
                    'passportExpiryDate': passportExpiryDate
                })
                passportFrontImageList.push(passportFrontImage)
                passportFrontImageTypeList.push(passportFrontImageType)
                console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx", visaApplicationList)
                this.setState({ visaApplicationList: visaApplicationList })
                setTimeout(() => { this.ClearValue() }, 200);
            }
            else {
                toastError('Please enter proper fields')
            }
        }
        else {
            toastError('Please enter mandatory fields')
            console.log('Please enter mandatory fields')
        }
        console.log(this.state.visaApplicationList)
    }

    handleSave() {
        const { visaApplicationList, passportFrontImageList, passportFrontImageTypeList } = this.state
        this.setState({ isLoading: true })
        this.props.addVisaApplication_action(visaApplicationList, passportFrontImageList, passportFrontImageTypeList)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Record Added Successfully")
                    setTimeout(() => {
                        this.setState({ isLoading: false })
                        this.props.navigate('/visaApplication')
                    }, 300);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    handleUpdate() {

        const { VisaApplicationFormID, visaApplicationList, passportFrontImageList, passportFrontImageTypeList, firstName, lastName, middleName, email, countryId, passportImage,
            mobile, idTypeId, passportNo, passportFrontImage, passportFrontImageType, countryList, idTypeList,
            firstNameErr, lastNameErr, emailErr, countryIdErr, mobileErr, idTypeIdErr, passportNoErr, passportFrontImageErr,
            passportExpiryDate, passportExpiryDateErr, passportIssueDate, passportIssueDateErr
        } = this.state
        this.inputValidate()
        if (firstName != '' && countryId != '' &&
            lastName != '' && mobile != '' &&
            email != '' && idTypeId != '' && passportExpiryDate != "" && passportIssueDate != "" &&
            passportNo != '' && ((passportImage == '' || passportImage == null) ? (passportFrontImage != '' &&
                passportFrontImageType != '') : true)) {
            if (firstNameErr == '' && lastNameErr == '' && emailErr == '' && countryIdErr == '' && mobileErr == '' && idTypeIdErr == '' &&
                passportNoErr == '' && ((passportImage == '' || passportImage == null) ? passportFrontImageErr == '' : true) &&
                passportExpiryDateErr == '' && passportIssueDateErr == ''
            ) {
                this.setState({ isLoading: true })
                this.props.updateVisaApplication_action(VisaApplicationFormID, firstName, middleName, lastName, email, countryId, mobile,
                    idTypeId, passportNo, passportFrontImage, passportFrontImageType, passportIssueDate, passportExpiryDate)
                    .then((data) => {
                        if (data.error != 1) {
                            toastSuccess("Record updated Successfully")
                            setTimeout(() => {
                                this.setState({ isLoading: false })
                                this.props.navigate('/visaApplication')
                            }, 300);
                        }
                        else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            }
        }
    }

    getDetails(id) {
        const { } = this.state
        this.setState({ isLoading: true })
        // var id = VisaApplicationFormID
        this.props.getDetailsVisaApplicationDelegate_action(id)
            .then((data) => {
                console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx", data.data)
                if (data.error != 1) {
                    this.setState({
                        firstName: data.data[0]['NameOnPassport'],
                        email: data.data[0]['ApplicantEmailID'],
                        countryId: data.data[0]['CountryID'],
                        mobile: data.data[0]['ApplicantMobileNo'],
                        countryName: data.data[0]['CountryName'],
                        passportNo: data.data[0]['PassportNo'],
                        passportIssueDate: new Date(data.data[0]['PassportIssueDate']),
                        passportExpiryDate: new Date(data.data[0]['PassportExpiryDate']),
                        isLoading: false,
                    })
                    var filePath = data.data[0]['PassportFilePath']
                    var array = data.data[0]['PassportFilePath'] != null &&
                        data.data[0]['PassportFilePath'] != "" && filePath.split("/")
                    const FileName = array[array.length - 1]
                    this.setState({
                        passportFilePath: filePath,
                        passportImage: FileName
                    })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    ClearValue() {
        this.setState({
            firstName: '',
            lastName: '',
            middleName: '',
            email: '',
            countryId: '',
            mobile: '',
            idTypeId: '',
            passportNo: '',
            passportFrontImage: '',
            passportImage: '',
            // passportExpiryDate: "",
            // passportIssueDate: ""
        })
        // document.getElementById("path").value = ""
    }

    onCrossClick() {
        this.setState({ passportFrontImage: "" })
        document.getElementById("path").value = ""
    }

    // On Document Delete Modal Toggle
    onDocDelete() {
        const { isDelOpen } = this.state
        this.setState({ isDelOpen: !isDelOpen })
    }

    // Delete Passport Document Delete
    handleDelete(e) {
        e.preventDefault()
        const { isDelOpen, VisaApplicationFormID, passportImage } = this.state
        this.setState({ isLoading: true })
        this.props.deleteVisaApplicationDoc_action(VisaApplicationFormID)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Passport Front Image Document Deleted SuccessFully")
                    this.setState({ isLoading: false, isDelOpen: !isDelOpen, passportImage: "" })
                } else {
                    toastError(data.msg)
                    this.setState({ isLoading: false })
                }
            }).catch((error) => {
                console.log(error)
            })
    }

    render() {
        const { isLoading, is_add, is_update, firstName, firstNameErr, middleName, lastName, lastNameErr, idTypeId, idTypeIdErr, passportFrontImage,
            passportFrontImageErr, countryId, countryIdErr, countryList, passportExpiryDate, passportExpiryDateErr, passportIssueDate, passportIssueDateErr,
            email, emailErr, passportNo, passportNoErr, mobile, mobileErr, visaApplicationList, idTypeList, passportImage, isDelOpen, isView,
            passportFilePath, countryName, url
        } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer></ToastContainer>
                <HeaderWithLogo />
                <AdminDrawer />
                <div className="main-content app-content with-dr-container">
                    <div className="main-container">
                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed ">
                                <h6 className="mb-0 px-2 py-2 text-white">Invitation letter for visa Application-Delegate</h6>
                            </div>
                        </div>
                        <div className="row vendor-top-space mx-0 px-0">
                            <div className="col-xl-12 p-0">
                                <div className="card rounded-0 pt-1 shadow-none">

                                    <div className="card-body p-2 mt-1">
                                        <div className="row">
                                            <div className="col-xl-4">
                                                <label htmlFor="validationCustom03">
                                                    Name (As per Passport)
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    disabled={true}
                                                    required=""
                                                    maxLength={'50'}
                                                    value={firstName}
                                                    onChange={(e) => this.setState({ firstName: e.target.value, firstNameErr: '' })}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{firstNameErr}</span>}

                                            </div>
                                            <div className="col-xl-4">
                                                <label htmlFor="validationCustom03">Applicant email id</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    maxLength={'50'}
                                                    value={email}
                                                    disabled={true}
                                                    // onChange={(e) => this.setState({ email: e.target.value, emailErr: '' })}
                                                    onChange={(e) => this.emailValidation(e)}
                                                />

                                                {<span className='text-danger text-start text-left d-block mt-1'>{emailErr}</span>}
                                            </div>
                                            <div className="col-xl-4">
                                                <label htmlFor="validationCustom03">Passport issuing Country</label>
                                                <select className="form-control"
                                                    value={countryId}
                                                    disabled={true}
                                                    onChange={(e) => this.setState({ countryId: e.target.value != '' && e.target.value, countryIdErr: '' })}  >
                                                    <option value={''}>Select</option>
                                                    {
                                                        countryList.length > 0 && countryList.map(data => (
                                                            <option value={data.Code} key={data.Code}>{data.Description}</option>
                                                        ))
                                                    }
                                                </select>

                                                {<span className='text-danger text-start text-left d-block mt-1'>{countryIdErr}</span>}
                                            </div>

                                        </div>
                                        <div className="row mt-2">


                                            <div className="col-xl-4">
                                                <label htmlFor="validationCustom03">Applicant Mobile</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    required=""
                                                    maxLength={'20'}
                                                    value={mobile}
                                                    disabled={true}
                                                    // onChange={(e) => this.setState({ mobile: e.target.value, mobileErr: '' })}
                                                    onChange={(e) => this.mobileValidation(e)}
                                                />

                                                {<span className='text-danger text-start text-left d-block mt-1'>{mobileErr}</span>}
                                            </div>
                                            <div className="col-xl-4">
                                                <label htmlFor="validationCustom03">Passport No</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="validationCustom03"
                                                    maxLength={'20'}
                                                    required=""
                                                    value={passportNo}
                                                    disabled={true}
                                                    onChange={(e) => this.setState({ passportNo: e.target.value, passportNoErr: '' })}
                                                />

                                                {<span className='text-danger text-start text-left d-block mt-1'>{passportNoErr}</span>}
                                            </div>
                                            <div className="col-xl-4">
                                                <label className="">Passport issue Date
                                                    <span className="text-red">*</span>
                                                </label>
                                                <DatePicker
                                                    selected={passportIssueDate}
                                                    onChange={(date) =>
                                                        this.setState({
                                                            passportIssueDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                            passportIssueDateErr: ""
                                                        })}
                                                    disabled={true}
                                                    dateFormat={"dd/MM/yyyy"} className="form-control"
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    maxDate={passportExpiryDate}
                                                    dropdownMode="select"
                                                    placeholderText="Passport Issued Date"
                                                    dayClassName={() => "example-datepicker-day-class"}
                                                    popperClassName="example-datepicker-class" />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{passportIssueDateErr}</span>}
                                            </div>
                                        </div>
                                        <div className="row mt-2">
                                            <div className="col-xl-4">
                                                <label className="mt-3">Passport Expiry Date
                                                    <span className="text-red">*</span>
                                                </label>
                                                <DatePicker
                                                    selected={passportExpiryDate}
                                                    onChange={(date) =>
                                                        this.setState({
                                                            passportExpiryDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                            passportExpiryDateErr: ""
                                                        })}
                                                    disabled={true}
                                                    dateFormat={"dd/MM/yyyy"} className="form-control"
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    minDate={passportIssueDate}
                                                    dropdownMode="select"
                                                    placeholderText="Passport Expiry Date"
                                                    dayClassName={() => "example-datepicker-day-class"}
                                                    popperClassName="example-datepicker-class" />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{passportExpiryDateErr}</span>}
                                            </div>
                                            <div className="col-xl-4">
                                                <label htmlFor="validationCustom03" className="mt-3">
                                                    Passport Front Page (Upto 5MB){" "}
                                                </label>
                                                <div className="box">
                                                    <div className="js--image-preview" />

                                                    {
                                                        // is_add ?
                                                        //     <div className="upload-options mt-1">
                                                        //         <label>
                                                        //             <input
                                                        //                 type="file"
                                                        //                 id="path"
                                                        //                 className="image-upload"
                                                        //                 accept=".jpg, .jpeg, .png, .pdf"
                                                        //                 onChange={e => this.onFilePick(e, e.target.files)}
                                                        //                 disabled={isView}
                                                        //             />
                                                        //             {
                                                        //                 passportFrontImage != "" &&
                                                        //                 <i class="fa fa-times text-danger img-can"
                                                        //                     onClick={() => this.onCrossClick()}></i>
                                                        //             }
                                                        //         </label>

                                                        //     </div> : passportImage != "" && passportImage != null ?
                                                        <div style={{
                                                            border: '1px solid #ccc',
                                                            padding: '10px',
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            // marginTop: '10px'
                                                        }}>
                                                            <a
                                                                href={passportFilePath}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                <span style={{ marginRight: '10px' }}
                                                                >{passportImage}</span>
                                                                <i className={`fa fa-times text-danger img-can ${true ? 'disabled' : ''}`}
                                                                // onClick={!isView ? (e) => this.onDocDelete() : undefined}
                                                                ></i>
                                                            </a>
                                                        </div>
                                                        // : <label>
                                                        //     <input
                                                        //         type="file"
                                                        //         id="path"
                                                        //         className="image-upload"
                                                        //         accept=".jpg, .jpeg, .png, .pdf"
                                                        //         disabled={isView}
                                                        //         onChange={e => this.onFilePick(e, e.target.files)}
                                                        //     />
                                                        //     {
                                                        //         passportFrontImage != "" &&
                                                        //         <i class="fa fa-times text-danger img-can" onClick={() => this.onCrossClick()}></i>
                                                        //     }
                                                        // </label>
                                                    }
                                                </div>
                                                {<span className='text-danger text-start text-left d-block mt-1'>{passportFrontImageErr}</span>}
                                            </div>
                                        </div>


                                        <hr />
                                        <div>
                                            <iframe
                                                title="Passport Front Page"
                                                src={url + passportFilePath}
                                                style={{ width: "800px", height: "1000px" }}
                                            />
                                        </div>
                                        <div className="row mt-4">
                                            <div className="btn-group mt-4 save-can d-block" role="group" aria-label="Basic example">

                                                {
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary rounded-0"
                                                        style={{ marginRight: '10px', width: '100px' }}
                                                        onClick={() => this.OnCancel()}
                                                    >
                                                        Back
                                                    </button>
                                                }

                                                {/* <button type="button" class="btn btn-primary rounded-0">Payment Listing Page</button> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal isOpen={isDelOpen} onRequestClose={() => this.setState({ isDelOpen: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content confirm-logout">
                            <div class="modal-header p-2">
                                <h5 class="modal-title">Confirm Delete</h5>
                                <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isDelOpen: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <p class="pop_label">Do you really want to delete this Document?</p>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-aqua"
                                        onClick={(e) => this.handleDelete(e)}
                                    >Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isDelOpen: false })}>No</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal>
            </>
        )
    }
}
export default withRouter(connect(null, { fill_action, getDetailsVisaApplicationDelegate_action })(DelegateVisaForm))